import { render, staticRenderFns } from "./DuplicateDateForm.vue?vue&type=template&id=890ecb90"
import script from "./DuplicateDateForm.vue?vue&type=script&lang=js"
export * from "./DuplicateDateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports